import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AdminSignInComponent} from './sign-in/admin-sign-in.component';
import {ShareComponent} from './cabinet/dam/share/share.component'
import {ExternalUploadComponent} from './cabinet/dam/external-upload/external-upload.component'

/**
 * Routes available in application
 *
 * @usageNotes
 * path: '', redirectTo: '/sign-in' - redirect to sign-in form
 * path: '', loadChildren: 'src/app/auth/auth.module#AuthModule' - lazy loading of auth module
 * {@link https://angular.io/guide/router}
 * {@link https://angular.io/guide/lazy-loading-ngmodules}
 */
const routes: Routes = [
  {path: 'share/:shareSyncUid', component: ShareComponent},
  {path: 'upload/:externalUploadSyncUid', component: ExternalUploadComponent},
  {path: 'sign-in', component: AdminSignInComponent},
  {path: '**', redirectTo: '/sign-in', pathMatch: 'full'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
